import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-214d34eb")

_pushScopeId("data-v-214d34eb")
const _hoisted_1 = {
  key: 0,
  class: "icon"
}
const _hoisted_2 = {
  key: 1,
  class: "absolute-content"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("button", {
    class: ["selectable-button flex flex--valign-c flex--halign-c", { selected: _ctx.selected, primary: _ctx.primary, circular: _ctx.circular }],
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)), ["stop"]))
  }, [
    (_ctx.identifier)
      ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.identifier), 1))
      : _createCommentVNode("", true),
    _createVNode("span", {
      class: ["text text--size-20 text--semi-bold text--less-gap", { 'text--color-white text--shadow': _ctx.selected, 'text--primary-b': !_ctx.selected }]
    }, _toDisplayString(_ctx.title), 3),
    (!!_ctx.$slots.absoluteContent)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "absoluteContent", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
})